import { effect, LOCALE_ID, NgModule, Provider, Type } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { registerLocaleData } from '@angular/common';
import { I18nHelper } from '@dibsondance/shared-translations';

import localeEn from '@angular/common/locales/en';
import localePl from '@angular/common/locales/pl';

import 'moment/locale/pl';
import 'moment/locale/en-gb';

registerLocaleData(localeEn);
registerLocaleData(localePl);

/**
 * Creates Material Configuration providers for DOD-Host
 *
 * Provides Angular Material date adapter and locale configuration:
 * - DateAdapter using Moment.js
 * - Locale management via I18nHelper (injected from app level)
 * - Date format configuration
 * - Reactive locale switching
 *
 * @param i18nHelperToken - Injection token for I18nHelper service
 * @returns Array of providers for Material configuration
 */
export function provideMaterialConfigHost(
  i18nHelperToken: Type<I18nHelper>
): Provider[] {
  return [
    {
      provide: LOCALE_ID,
      deps: [i18nHelperToken],
      useFactory: (i18nHelper: I18nHelper) => {
        return i18nHelper.currentLang();
      },
    },
    {
      provide: MAT_DATE_LOCALE,
      deps: [i18nHelperToken],
      useFactory: (i18nHelper: I18nHelper) => {
        return i18nHelper.currentLang();
      },
    },
    {
      provide: MAT_DATE_FORMATS,
      deps: [i18nHelperToken],
      useFactory: (i18nHelper: I18nHelper) => {
        return i18nHelper.currentFormat();
      },
    },
    {
      provide: DateAdapter,
      useFactory: (locale: string, i18nHelper: I18nHelper) => {
        const adapter = new MomentDateAdapter(locale);
        effect(() => {
          adapter.setLocale(i18nHelper.currentLang());
        });
        return adapter;
      },
      deps: [MAT_DATE_LOCALE, i18nHelperToken],
    },
  ];
}

@NgModule({
  imports: [MatMomentDateModule],
  exports: [MatMomentDateModule],
})
export class MaterialConfigHostModule {}
